import { render, staticRenderFns } from "./PdvPrePostDC.vue?vue&type=template&id=640c27b0"
import script from "./PdvPrePostDC.vue?vue&type=script&lang=js"
export * from "./PdvPrePostDC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports